<template>
  <div>
    <!-- {{ subChecklist }} -->
    <div v-for="block in visibleBlocks" :key="block.id">
      <h3>{{ subChecklist.title }} #{{ block.sequenceNumber }}</h3>

      <div v-for="field in block.values" :key="field.id">
        <!-- {{ field }} -->
        
            <checklist-filled-details-field
              ref="checklistFilledDetailsField"
              :checklist-value="field"
              :pendencyFieldId="field.fieldId"
              @after-attachment-show="verifyShowingEveryAttachments"
            >
            </checklist-filled-details-field>
          
      </div>
      <!-- {{ block }} -->
    </div>
  </div>
</template>


<script>
export default {
  name: "SubChecklistFilledDetailsField",
  props: {
    subChecklist: Object,
  },
  components: {
    ChecklistFilledDetailsField: () =>
      import(
        "@/components_rms/checklist/filled/ChecklistFilledDetailsField.vue"
      ),
  },
  data() {
    return {
      isShowingEveryAttachments: false,
    };
  },
  computed: {
    visibleBlocks() {
      if (!this.subChecklist || !this.subChecklist.subBlock) {
        return [];
      }

      return this.subChecklist.subBlock.filter(
        (block) => block && block.active !== false && block.hide !== true
      );
    },
  },
  methods: {
    verifyShowingEveryAttachments() {
      let total = 0;
      let showing = 0;
      this.$refs.checklistFilledDetailsField.forEach((detailField) => {
        if (detailField.checklistValue.hasAttachment) {
          total++;
          if (detailField.isShowingAttachment) {
            showing++;
          }
        }
      });
      this.isShowingEveryAttachments = total == showing;
    },
  },
};
</script>

